//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        building_id: {
            type: [String, Number]
        },
        item: {
            type: Object,
            default: {
                content_body: {
                    image_url: '',
                    title: '',
                    abstract: ''
                }
            }
        }
    },
    methods: {
        openDetail () {
            this.$router.push({
                path:`/pages/building/visit_building/main?building_id=${this.building_id}&id=${this.item.id}`
            })
        }
    }
}
